import { makeStyles } from 'tss-react/mui';

// Styles
import { colors } from '../../../../styles/palette';

const CONTROL_INDENT = 3;
const CONTROL_OFFSET = 42;
const CONTROL_GAP = 12;
export const useStyles = makeStyles()((theme) => ({
  required: {
    color: colors.gilead.primary1,
    marginRight: 2,
  },
  sectionLabel: {
    fontWeight: 700,
    marginBottom: theme.spacing(1),
  },
  noMargin: {
    marginBottom: 0,
  },
  controls: {
    paddingLeft: theme.spacing(CONTROL_INDENT),
    '& .MuiFormControlLabel-root': {
      marginLeft: 0,
      marginRight: 0,
    },
    '& .MuiRadio-root': {
      padding: 0,
      marginRight: theme.spacing(1),
    },
    '& .MuiCheckbox-root': {
      marginRight: theme.spacing(1),
    },
  },
  section: {
    marginBottom: theme.spacing(3),
  },
  subgroups: {
    display: 'grid',
    gridTemplateColumns: '1fr 1fr',
    gridAutoFlow: 'column',
    rowGap: CONTROL_GAP,
    [theme.breakpoints.down('md')]: {
      gridTemplateColumns: '1fr',
      gridAutoFlow: 'row',
    },
  },
  quantityRow: {
    alignItems: 'center',
    display: 'flex',
    gap: theme.spacing(2),
  },
  quantityInput: {
    maxWidth: 110,
    '& .MuiFormControl-root': {
      marginBottom: 0,
    },
  },
  hint: {
    color: theme.palette.darkGrey,
    fontSize: 12,
    lineHeight: '16px',
    paddingLeft: CONTROL_OFFSET,
  },
  option: {
    display: 'block',
    marginBottom: 12 + CONTROL_GAP,
  },
  radioGroup: {
    gap: CONTROL_GAP,
  },
  optionLabel: {
    marginBottom: 0,
    marginLeft: 0,
  },
}));
